import { defineStore } from "pinia";

import { IConvertToPendingPal } from "./i-state";
import {
    SET_PATIENT_ID,
    SET_ACCOUNT_ID,
    SET_PATIENT_DETAILS,
    SET_APPLICATION,
    SET_COUNTRY_LIST,
    SET_PATIENT_REFERRAL_ID,
    SET_PATIENT_OPTIONS,
    SET_ERRORS,
    RESET_ERRORS,
    SET_NEW_ERRORS,
    RESET_ALL_ERRORS
} from "./types";
import { ApplicationEnum } from "../../../../enums/enums";
import { IGetCountryCode } from "../../../../resources-vue/vue-interfaces/i-lookup";
import { PalliativeConvertToPending } from "../../../../resources-vue/vue-models/palliative-convert-to-pending";
import { ISlimResponse } from "../../../../interfaces/i-patient-service";

export const useConvertToPendingPal = defineStore("convert-to-pending-pal", {
    state: () =>
        ({
            patientDetails: new PalliativeConvertToPending(),
            patientId: "",
            accountId: "",
            providerId: "",
            application: ApplicationEnum.AxxessPalliative,
            countryList: null,
            patientReferralId: "",
            patientOptions: null,
            errors: {
                demographics: { errors: [], isValidated: false, hasErrors: false },
                payerInformation: { errors: [], isValidated: false, hasErrors: false },
                referralInformation: { errors: [], isValidated: false, hasErrors: false },
                clinicalInformation: { errors: [], isValidated: false, hasErrors: false },
                healthHistory: { errors: [], isValidated: false, hasErrors: false },
                providers: { errors: [], isValidated: false, hasErrors: false },
                pharmacyAndDme: { errors: [], isValidated: false, hasErrors: false },
                authorizedContacts: { errors: [], isValidated: false, hasErrors: false },
                emergencyPreparedness: { errors: [], isValidated: false, hasErrors: false },
                advanceDirectives: { errors: [], isValidated: false, hasErrors: false },
                patientGoals: { errors: [], isValidated: false, hasErrors: false },
                patientNotes: { errors: [], isValidated: false, hasErrors: false },
                myNotes: { errors: [], isValidated: false, hasErrors: false },
                primaryAddress: [],
                visitAddress: [],
                mailingAddress: [],
                previousAddress: [],
                serviceLocation: [],
                evacuationAddress: []
            }
        }) as IConvertToPendingPal,
    actions: {
        [SET_PATIENT_ID](id: string) {
            this.patientId = id;
        },
        [SET_ACCOUNT_ID](id: string) {
            this.accountId = id;
        },
        [SET_PATIENT_DETAILS](payload: PalliativeConvertToPending) {
            this.patientDetails = payload;
        },
        [SET_APPLICATION](application: ApplicationEnum.AxxessPalliative) {
            this.application = application;
        },

        [SET_COUNTRY_LIST](payload: IGetCountryCode[]) {
            this.countryList = payload;
        },
        [SET_PATIENT_REFERRAL_ID](payload: string | string[]) {
            this.patientReferralId = payload;
        },
        [SET_PATIENT_OPTIONS](payload: ISlimResponse) {
            this.patientOptions = payload;
        },
        [SET_ERRORS](payload: any, isValidated: boolean, hasErrors: boolean) {
            this.errors[payload.property].errors.push(payload.error);
            this.errors[payload.property].isValidated = isValidated;
            this.errors[payload.property].hasErrors = hasErrors;
        },
        [RESET_ERRORS](property: any) {
            this.errors[property].errors = [];
            this.errors[property].isValidated = false;
            this.errors[property].hasErrors = false;
        },
        [SET_NEW_ERRORS](payload: any, isValidated: boolean, hasErrors: boolean) {
            this.errors[payload.property].errors = payload.value;
            this.errors[payload.property].isValidated = isValidated;
            this.errors[payload.property].hasErrors = hasErrors;
        },
        [RESET_ALL_ERRORS]() {
            this.errors = {
                demographics: { errors: [], isValidated: false, hasErrors: false },
                payerInformation: { errors: [], isValidated: false, hasErrors: false },
                referralInformation: { errors: [], isValidated: false, hasErrors: false },
                clinicalInformation: { errors: [], isValidated: false, hasErrors: false },
                healthHistory: { errors: [], isValidated: false, hasErrors: false },
                providers: { errors: [], isValidated: false, hasErrors: false },
                pharmacyAndDme: { errors: [], isValidated: false, hasErrors: false },
                authorizedContacts: { errors: [], isValidated: false, hasErrors: false },
                emergencyPreparedness: { errors: [], isValidated: false, hasErrors: false },
                advanceDirectives: { errors: [], isValidated: false, hasErrors: false },
                patientGoals: { errors: [], isValidated: false, hasErrors: false },
                patientNotes: { errors: [], isValidated: false, hasErrors: false },
                myNotes: { errors: [], isValidated: false, hasErrors: false },
                primaryAddress: [],
                visitAddress: [],
                mailingAddress: [],
                previousAddress: [],
                serviceLocation: [],
                evacuationAddress: []
            } as any;
        }
    }
});
